module.exports = __webpack_public_path__ + "static/img/75086J_1_R_20201123_LC.e34edcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/75086J_1_R_20201123_LC.png
// module id = 4n88
// module chunks = 0